import React from "react";
import { useOutletContext } from "react-router-dom";
import { PortalLegalPage } from "@/components/legal/PortalLegalPage";

export default function BpReglement() {
  const { refresh } = useOutletContext();
  return <PortalLegalPage portal="bp" onAccepted={refresh} />;
}
